import React from 'react'
import axios from 'axios'

var UserStateContext = React.createContext()
var UserDispatchContext = React.createContext()

function userReducer(state, action) {
	switch (action.type) {
		case 'LOGIN_SUCCESS':
			return { ...state, isAuthenticated: true, user: JSON.parse(localStorage.getItem('user')) }
		case 'SIGN_OUT_SUCCESS':
			return { ...state, isAuthenticated: false, user: null }
		default: {
			throw new Error(`Unhandled action type: ${action.type}`)
		}
	}
}


function UserProvider({ children }) {
	var [state, dispatch] = React.useReducer(userReducer, {
		isAuthenticated: !!localStorage.getItem('auth_token'),
		user: JSON.parse(localStorage.getItem('user')),
	})

	return (
		<UserStateContext.Provider value={state}>
			<UserDispatchContext.Provider value={dispatch}>
				{children}
			</UserDispatchContext.Provider>
		</UserStateContext.Provider>
	)
}

function useUserState() {
	var context = React.useContext(UserStateContext)
	if (context === undefined) {
		throw new Error('useUserState must be used within a UserProvider')
	}
	return context
}


function useUserDispatch() {
	var context = React.useContext(UserDispatchContext)
	if (context === undefined) {
		throw new Error('useUserDispatch must be used within a UserProvider')
	}
	return context
}

export { UserProvider, useUserState, useUserDispatch, loginUser, signOut }

// ###########################################################

function loginUser(dispatch, login, password, history, setIsLoading, setError) {
	setError(false)
	setIsLoading(true)

	if (!!login && !!password) {
		axios
			.post(`/api/users/login`, { email: login, password })
			.then(async (res) => {
				localStorage.clear()
				localStorage.setItem('auth_token', res.data.data.user.token)
				localStorage.setItem('user', JSON.stringify(res.data.data.user))
				localStorage.setItem('company', JSON.stringify(res.data.data.company))
				axios.defaults.headers.common['Authorization'] = `Bearer ${
					res.data.data.user.token
					}`
				await getPermissions()
				setError(false)
				setIsLoading(false)
				dispatch({ type: 'LOGIN_SUCCESS' })
			})
			.catch(function (error) {
				// handle error
				setError(true)
				setIsLoading(false)
			})
	} else {
		setError(true)
		setIsLoading(false)
	}
}

async function getPermissions() {
	try {
		const res = await axios.get('/api/user/permissions')
		localStorage.setItem('user_permissions', res.data.data)
	}catch(e) {
		console.log(e)
	}
}

function signOut(dispatch, history) {

	localStorage.clear()
	axios.defaults.headers.common['Authorization'] = ''
	delete axios.defaults.headers.common['Authorization']
	if (history !== null) {
		dispatch({ type: 'SIGN_OUT_SUCCESS' })
		history.push('/login')
	} else {
		console.log('Refreshing page')
		window.location.reload();
	}
}
